import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import { SnackbarType } from "../components/sharedComponents/Snackbar";
import { AUTH_API } from "../components/routeComponents/Authentication/HelperFunctions";
import { PersonUserForm } from "../components/routeComponents/Persons/Person";

const useSendResetPasswordEmailMutation = () => {
  const create = useMutation(
    (req: FormData) => AUTH_API.post(`/resetpassword/requestToken`, req),
    ResponseHandling("reset_email_sent")
  );

  const mutate = async (user: PersonUserForm) => {
    const domain = user.customer.customerDomainName;
    const username = user.displayedLoginName;

    const formData = new FormData();
    formData.append("domain", domain);
    formData.append("username", username);

    return await create.mutateAsync(formData);
  };

  return {
    mutations: {
      mutate,
      isLoading: create.isLoading,
      create: {
        isSuccess: create.isSuccess,
      },
    },
  };
};

export default useSendResetPasswordEmailMutation;

function ResponseHandling(messageKey: string = "reset_email_sent") {
  const { showSnackbar } = useSnackbarActionContext();
  const { t } = useTranslation();

  return {
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
    onSuccess: () => {
      showSnackbar(SnackbarType.Success, t(messageKey));
    },
  };
}
